(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('GroupProductDialogController', GroupProductDialogController);

    GroupProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'GroupProduct','CommonService'];

    function GroupProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, GroupProduct,CommonService) {
        var vm = this;
        vm.lstProductShow = CommonService.query({masterurl:'find-product-by-status'});
        vm.lstProductSave = [];
        vm.groupProduct = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
//        vm.checkLoad = checkLoad();
        vm.flagLoadList = false;
       
        if (vm.groupProduct.productGroupId != null || vm.groupProduct.productGroupId != undefined) {
       	 vm.checkcreat = true;
       	vm.groupProduct.isExit = true;
       	vm.groupProduct.beginDate = new Date(vm.groupProduct.beginDate);
        vm.groupProduct.endDate = new Date(vm.groupProduct.endDate);
       	vm.lstProductSave = CommonService.query({masterurl:'find-product-by-group',productGroupId :vm.groupProduct.productGroupId});
        }else{
    	   vm.groupProduct.isExit = false;
    	   vm.groupProduct.beginDate = new Date();
           vm.groupProduct.endDate = new Date();
           vm.groupProduct.status="0";
        }
        function checkLoad(){
        	if(vm.lstProductSave.length > 0){
        		vm.flagLoadList = true;
        		return;
        	}
        	vm.flagLoadList = false;
        }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            vm.groupProduct.listProductItem = vm.lstProductSave;
            if (vm.groupProduct.isExit == true) {
            	GroupProduct.update(vm.groupProduct,function(result){
          		  $scope.$emit('masterApp:groupProductUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
        		});
            } else {
            	GroupProduct.save(vm.groupProduct,function(result){
        		  $scope.$emit('masterApp:groupProductUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
            	});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:groupProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function onSaveError () {
            vm.isSaving = false;
        }
        function onSaveError () {
            vm.isSaving = false;
        }
        vm.openFromDate = function() {
    		vm.popupFromDate.opened = true;
    	};
    	vm.openToDate = function() {
    		vm.popupToDate.opened = true;
    	};
    	$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
    			'shortDate' ];
    	$scope.format = $scope.formats[2];
    	$scope.altInputFormats = [ 'dd/MM/yyyy' ];

    	vm.popupFromDate = {
    		opened : false
    	};

    	vm.popupToDate = {
    		opened : false
    	};
    	
    	if(vm.groupProduct!=undefined){
			vm.dateEndOptions = {
					minDate : vm.groupProduct.beginDate,
					maxDate : new Date()
			};
		}
    	
    	vm.dateOptions = {
    		    maxDate: new Date()
    	};
    	vm.validateDates =function () {
    		vm.dateEndOptions = {
					minDate : vm.groupProduct.beginDate,
					maxDate : new Date()
			};
	    };
//    	vm.dateOptions = {
////    		    maxDate: new Date()
//    		  };
//    	vm.validateDates =function () {
//			$scope.clearMessage();
//			
//    	    var currentDate = new Date();
//    	        var toDate = moment($scope.vm.groupProduct.endDate,"DD/MM/YYYY");
//    	        var fromDate = moment($scope.vm.groupProduct.beginDate,"DD/MM/YYYY");
//    	      /*  if (currentDate < toDate){
//    	        	vm.checkDate = true;
//    	        	$scope.addAlert('Vui lòng chọn [Ngày Kết Thúc] bằng hoặc nhỏ hơn ngày hiện tại.','error');
//    	        }else if (currentDate < fromDate){
//        	        	vm.checkDate = true;
//        	        	$scope.addAlert('Vui lòng chọn [Ngày Bắt Đầu] bằng hoặc nhỏ hơn ngày hiện tại.','error');
//        	    }else */
//        	    	if (toDate.diff(fromDate) < 0){
//    	        	vm.checkDate = true;
//    	        	$scope.addAlert('Vui lòng chọn [Ngày Kết Thúc] lớn hơn hoặc bằng [Ngày Bắt Đầu].','error');
//    	        }else{
//    	        	vm.checkDate = false;
//    	        }
//	    	};

		$scope.addRow = function(item, type) {
			if(item == null || item == undefined || item == ''){
				$scope.clearMessage();
				$scope.addAlert('Chọn hàng hóa/ấn phẩm','warning');
				return;
			}
			if(type != 1){
				vm.lstProductShow.push(item);
			}else{
				vm.lstProductSave.push(item);
				$scope.removeRow(item, 0);
			}
			
		};
		$scope.removeRow = function(item,typeList) {
			$scope.clearMessage();
			var index = -1;
			var comArr = null;
			if(typeList == 1){
				comArr =  eval($scope.vm.lstProductSave);
			}else{
				comArr =  eval($scope.vm.lstProductShow);
			}
			
			for (var i = 0; i < comArr.length; i++) {
				if (comArr[i].productId === item.productId) {
					index = i;
					break;
				}
			}
			if (index === -1) {
				$scope.addAlert('Lỗi thêm hàng hóa/ấn phẩm','error');
				return;
			}
			if(typeList == 1){
				$scope.vm.lstProductSave.splice(index, 1);
				$scope.addRow(item, 0);
				checkLoad();
			}else{
				$scope.vm.lstProductShow.splice(index, 1);
				$scope.vm.option = '';
				checkLoad();
			}
			
		};
    }
})();
